export function roundToDecimals(value: number, decimals: number = 2): number {
    const factor = 10 ** decimals;

    // Handle negative numbers differently to avoid rounding issues
    if (value < 0) {
        return Math.round((value - Number.EPSILON) * factor) / factor;
    }

    return Math.round((value + Number.EPSILON) * factor) / factor;
}

export function roundArrayOfStringNumbers(
    numbers: string[],
    decimals: number = 2,
): string[] {
    return numbers.map((number) =>
        roundToDecimals(Number(number), decimals).toString(),
    );
}
